// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"houses"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M5 21V9.25L12 3L19 9.22222V21H5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M10.0003 15V21H14.0003V15H10.0003Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10.0003 21V15H14.0003V21H10.0003ZM10.0003 21C10.3133 21 9.64381 21 10.0003 21Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 11L12 3L3 11M5 9.97606V21H19V9.95M7 6.75V4","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-houses')
export default class HousesIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'houses',
    }
  }
}
